// Input.tsx
import React, { useState } from "react";
import Button from "./Button";

interface InputProps {
  placeholder: string;
  buttonLabel: string;
  onSubmit: (value: string) => void;
}

const Input: React.FC<InputProps> = ({
  placeholder,
  buttonLabel,
  onSubmit,
}) => {
  const [value, setValue] = useState("");

  const handleSubmit = () => {
    onSubmit(value);
    setValue("");
  };

  // Determine text color based on whether the input is filled
  const inputTextColor = value ? "text-[#04262b]" : "text-[#797e7c]";

  const containerClasses = [
    "flex",
    "items-center",
    "gap-4",
    "pl-4",
    "pr-1",
    "py-1",
    "bg-[#fcfbf8]",
    "rounded-md",
    "w-full",
    "border",
    "border-[#e3e3de]", // Default border color
    "hover:border-[#d0d2cc]", // Hover border color
    "focus-within:border-2", // Active border width
    "focus-within:border-[#04262b]", // Active border color
    "transition", // Smooth transitions
  ].join(" ");

  const inputClasses = [
    "flex-grow",
    "text-base",
    "font-medium",
    "font-['Manrope']",
    "leading-7",
    "tracking-tight",
    "outline-none",
    "bg-transparent",
    "border-none",
    inputTextColor, // Dynamic text color
    "placeholder-[#797e7c]", // Placeholder text color
  ].join(" ");

  return (
    <div className={containerClasses}>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className={inputClasses}
      />
      <Button
        label={buttonLabel}
        style="Primary"
        size="Base"
        onClick={handleSubmit}
      />
    </div>
  );
};

export default Input;
